import { useSignals } from '@preact/signals-react/runtime'
import { MateList } from '../MateList/MateList'
import { useWebContainer } from '../../../providers/DepProvider/DepProvider'
import { MateListPanel } from '../MateListPanel/MateListPanel'
import { OmniModeControls } from '../../omniModeControls/OmniModeControls/OmniModeControls'
import { useTheme } from '../../../../contexts/ThemeContext'

export function MateListContainer() {
  useSignals()

  const container = useWebContainer()
  const vm = container.mateListVM

  const { getPlayerColor } = useTheme()

  return (
    <MateListPanel>
      <OmniModeControls
        isOmniMode={vm.isOmniMode.value}
        roomHasOmniMates={vm.hasAnyOmniMate.value}
        hasActiveGame={vm.hasActiveGame.value}
        canUseOmniMode={container.debugPanelVM.canUseOmniMode.value}
        onToggleOmniMode={(enabled) => {
          const action = enabled ? container.debugPanelVM.applyOmniMode : container.debugPanelVM.exitOmniMode
          action().catch((e: any) => {
            console.error('[MateListContainer] setOmniMode failed:', e)
          })
        }}
        currentPlayerId={vm.currentPlayerId.value}
        omniMode={vm.omniMode}
        autoModeChecked={vm.autoMode.value}
        onAutoModeChange={vm.setAutoMode}
        playerCountOptions={vm.playerCountOptions.value}
        playerCount={vm.omniPlayerCount.value}
        onSetPlayerCount={vm.setPlayerCount}
        getPlayerColor={getPlayerColor}
      />
      <MateList
        mateListVM={vm}
        isGameOver={container.shellVM.game.isGameOver.value}
        onOurMateClick={() => { container.localMatesSystem.localMates.showNameDialog.value = true }}
      />
    </MateListPanel>
  )
}
